import React, { useState, useEffect } from "react";
import CustomFormControl from "features/bidding-center/Dropdown/CustomFormControl";
import { CloseOutlined } from "@mui/icons-material";
import "../RetargetingForm.scss";
import CustomOutlinedInput from "components/CustomOutlinedInput/CustomOutlinedInput";
import { Divider, MenuItem } from "@mui/material";
import { frequencyDropdownOptions, searchDropdownOptions } from "../utils";
import { validateDaysRange, validateOperator, validateSource } from "features/meta-travel-ads-campaign/Utils/validators/audienceValidators";

const DataSourceItem = ({ onRemove, onChange, id, item }) => {
  const [source, setSource] = useState("");
  const [operator, setOperator] = useState("");
  const [daysRange,setDaysRange] = useState({ days_from: "", days_to: "" });
  const [fieldErrors, setFieldErrors] = useState({ source: false, operator: false, days_from: false, days_to: false });

  // Pré-remplir les champs à partir de la prop item (édition)
  useEffect(() => {
    if (item) {
      setSource(item.source ?? "");
      setOperator(item.operator ?? "");
      const df = item?.daysRange?.days_from;
      const dt = item?.daysRange?.days_to;
      setDaysRange({
        days_from: df != null ? String(df) : "",
        days_to: dt != null ? String(dt) : "",
      });
    }
  }, [item]);

  const isAllBlank = (src, op, dr) => {
    return !src && !op && !dr.days_from && !dr.days_to;
  };

  const validatePartialFill = (src, op, dr) => {
    if (isAllBlank(src, op, dr)) {
      setFieldErrors({ source: false, operator: false, days_from: false, days_to: false });
      return;
    }
    setFieldErrors({
      source: !src,
      operator: !op,
      days_from: !dr.days_from || Number(dr.days_from) <= 0,
      days_to: !dr.days_to,
    });
  };

  const handleSourceChange = (e) => {
    const val = e.target.value;
    setSource(val);
    onChange(id, { ...item, source: val });
    validatePartialFill(val, operator, daysRange);
  };

  const handleOperatorChange = (e) => {
    const val = e.target.value;
    setOperator(val);
    onChange(id, { ...item, operator: val });
    validatePartialFill(source, val, daysRange);
  };

  const handleDaysFromChange = (e) => {
    const val = e.target.value;
    const newRange = { ...daysRange, days_from: val };
    setDaysRange(newRange);
    onChange(id, { ...item, daysRange: newRange });
    validatePartialFill(source, operator, newRange);
  };

  const handleDaysToChange = (e) => {
    const val = e.target.value;
    const newRange = { ...daysRange, days_to: val };
    setDaysRange(newRange);
    onChange(id, { ...item, daysRange: newRange });
    validatePartialFill(source, operator, newRange);
  };

  const handleSourceBlur = async () => {
    validatePartialFill(source, operator, daysRange);
    if (source) await validateSource(source);
  }

  const handleOperatorBlur = async () => {
    validatePartialFill(source, operator, daysRange);
    if (operator) await validateOperator(operator);
  }

  const handleDaysRangeBlur = async () => {
    validatePartialFill(source, operator, daysRange);
    if (daysRange.days_from && daysRange.days_to) {
      await validateDaysRange(Number(daysRange.days_from), Number(daysRange.days_to));
    }
  }

  return (
    <div className="data-source-item">
      <div className="dropdowns">
        <CustomFormControl
          minWidth={"165px"}
          displayEmpty
          error={fieldErrors.source}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#bab7b7",
                  }}
                >
                  Select a value
                </span>
              );
            }
            const opt = searchDropdownOptions.find(o => o.id === selected);
            return opt?.name ?? selected;
          }}
        onChange={handleSourceChange}
        value={source}
        onBlur={handleSourceBlur}
        MenuProps={{ PaperProps: { sx: { borderRadius: "5px", border: "1px solid #C4C4C4", boxShadow: "none" } } }}
        >
          {searchDropdownOptions.map((option) => (
            <MenuItem
             className="dropdown-item"
              key={option.id}
              value={option.id}
            >
              {option.name}
            </MenuItem>
          ))}
          <Divider sx={{ borderColor: "#CCC", width: "90%", margin : "auto" }} />
        </CustomFormControl>
        <CustomFormControl
          minWidth={"165px"}
          displayEmpty
          error={fieldErrors.operator}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#bab7b7",
                  }}
                >
                  Select a value
                </span>
              );
            }
            const opt = frequencyDropdownOptions.find(o => o.id === selected);
            return opt?.name ?? selected;
          }}
          onChange={handleOperatorChange}
          value={operator}
          onBlur={handleOperatorBlur}
          MenuProps={{ PaperProps: { sx: { borderRadius: "5px", border: "1px solid #C4C4C4", boxShadow: "none" } } }}
        >
          {frequencyDropdownOptions.map((option) => (
            <MenuItem
              className="dropdown-item"
              key={option.id}
              value={option.id}
            >
              {option.name}
            </MenuItem>
          ))}
          <Divider sx={{ borderColor: "#CCC", width: "90%", margin : "auto" }} />
        </CustomFormControl>    
      </div>
      <div className="age-inputs">
        <CustomOutlinedInput
          inputPaddingLeft={"5px"}
          minWidth={"42px"}
          inputPadding={"0px"}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          sx={{ maxWidth: "42px" }}
          value={daysRange.days_from}
          onChange={handleDaysFromChange}
          onBlur={handleDaysRangeBlur}
          error={fieldErrors.days_from}
        />
        <span> - </span>
        <CustomOutlinedInput
          inputPaddingLeft={"5px"}
          minWidth={"42px"}
          value={daysRange.days_to}
          onChange={handleDaysToChange}
          inputPadding={"0px"}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          sx={{ maxWidth: "42px" }}
          onBlur={handleDaysRangeBlur}
          error={fieldErrors.days_to}
        />
        <span className="filter-label">Days</span>
      </div>
      <span onClick={onRemove}>
        <CloseOutlined fontSize="12px" className="close-button" />
      </span>
    </div>
  );
};


export default DataSourceItem;